import React, { Fragment } from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import { StateContext } from "../../containers/sidebarContext";
import CoverBoxes from "../CoverBoxes";
import { useTranslation } from "react-i18next";
import DrinkContains from "../DrinkContains/DrinkContains";

const Beer = () => {
  const state = React.useContext(StateContext);
  const { isSidebarOpen } = state;
  const { t } = useTranslation();
  const beer = [
    { id: 1, contain: "1", title: "BECKS 0,33", price: "4.00" },
    { id: 2, contain: "1", title: "BECKS GOLD", price: "4.00" },
    { id: 3, contain: "1", title: "BECKS LEMON", price: "4.00" },
    { id: 4, contain: "1", title: "ALKOHOLFREIE BECKS", price: "4.00" },
    { id: 5, contain: "1", title: "HEINEKEN 0,25", price: "4.00" },
    { id: 6, contain: "1", title: "CORONA 0,35", price: "4.50" },
    { id: 7, contain: "1", title: "HEFEWEIZEN 0.5", price: "4.50" },
    { id: 8, contain: "1", title: "SOMERSBY", price: "3.50" },
  ];

  return (
    <Fragment>
      {isSidebarOpen && (
        <>
          <div
            style={{
              backgroundImage: `url(${blackBackground})`,
              backgroundSize: "cover",
            }}
            className="content beer__box"
          >
            <div className="table__header">
              {" "}
              <h2>{t("beer:beer")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {beer.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <sup>{item.contain}</sup> <span>{item.title}</span>
                    </td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <DrinkContains />
          </div>
          <CoverBoxes />
        </>
      )}
    </Fragment>
  );
};

export default Beer;
